import { css } from '@emotion/css'
import { Autocomplete } from '@mui/material'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import React from 'react'
import { useIntl } from 'react-intl'
import fullSubsidy from 'src/assets/images/financialSource/fullSubsidy.svg'
import { getStyles } from 'src/utils/utils/commonUtils'
import downIcon from '../../../../assets/images/common/daw-down-black.svg'

const styles = (theme, props) => ({
  autocompleteField: {
    background: theme.palette.background.default,
    borderRadius: 8,
  },
  districtInputFocused: {
    boxShadow: (props) =>
      `0 0 0 2px ${props.borderColor ? props.borderColor : '#A1A1A1'}`,
  },
  autocompleteFieldInput: {
    padding: '0 4px !important',
  },
  popupIndicator: {
    padding: 0,
    marginRight: '16px',
    '&:hover': {
      background: 'transparent',
    },
  },
  autocompleteListbox: {
    padding: 0,
  },
  currencyName: {
    fontSize: '18px',
    lineHeight: '28px',
    maxWidth: '300px',
    fontWeight: '400 !important',
  },
  menuItem: {
    borderRadius: '8px',
    width: '100%',
    background: '#FFF',
  },
  menuItemSelected: {
    background: '#EBF4FF !important',
  },
  option: {
    borderRadius: '8px',
    backgroundColor: '#F6ECDF !important',
    padding: 0,
    margin: '2px 0',
  },
  paper: {
    padding: '12px',
    margin: '6px 0',
    boxShadow: (props) =>
      `0 0 0 2px ${
        props.borderColor ? props.borderColor : '#A1A1A1'
      }, 0px 12px 16px -8px rgba(52, 52, 52, 0.12)`,
  },
})

function DefaultAutocomplete({
  value,
  onChange,
  error,
  label,
  placeholder,
  items,
  autocompleteOptions,
  handbookCollection,
  dotationOptions,
  showFullText,
  ...props
}) {
  const intl = useIntl()
  const classes = getStyles(styles)
  const [isDropdownOpen, setDropdownOpen] = React.useState(false)

  const selectPaper = (options) => (
    <Paper {...options} className={css(classes.paper)} />
  )

  const renderOption = (option) => {
    const selected = value === option.key
    const isDotation = dotationOptions?.includes(option.key)

    return (
      <MenuItem
        value={option.key}
        className={classNames(
          css(classes.menuItem),
          selected && css(classes.menuItemSelected),
        )}
        onClick={(e) => {
          onChange(option.key)
          setDropdownOpen(false)
        }}
      >
        <Box
          width={1}
          display={'flex'}
          flexWrap={'nowrap'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Typography
            variant={'subtitle1'}
            className={css(classes.currencyName)}
            sx={{
              overflow: showFullText ? 'visible!important' : 'hidden',
              textOverflow: showFullText ? 'auto!important' : 'ellipsis',
              textWrap: showFullText ? 'wrap' : undefined,
            }}
          >
            {option.key}
          </Typography>
          {isDotation && <img src={fullSubsidy} alt='full subsidy icon' />}
        </Box>
      </MenuItem>
    )
  }

  const onOpenSelect = (e) => {
    setDropdownOpen(true)
  }

  const onCloseSelect = () => {
    setDropdownOpen(false)
  }

  return (
    <>
      <Autocomplete
        clearOnBlur={false}
        value={value}
        inputValue={value}
        onInputChange={onChange}
        onChange={(event, value) => onChange(value)}
        options={handbookCollection}
        open={isDropdownOpen}
        disableClearable
        onOpen={onOpenSelect}
        getOptionLabel={(e) => e}
        onClose={onCloseSelect}
        PaperComponent={selectPaper}
        noOptionsText={intl.formatMessage({ id: 'Нет совпадений' })}
        renderOption={(option) => renderOption(option)}
        classes={{
          option: css(classes.option),
          popupIndicator: css(classes.popupIndicator),
          listbox: css(classes.autocompleteListbox),
        }}
        popupIcon={
          <img
            alt={''}
            src={downIcon}
            style={{
              height: '23px',
              width: '23px',
              marginRight: '7px',
              opacity: props.disabled ? '.3' : '.8',
            }}
          />
        }
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder={placeholder}
              label={label}
              error={error}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
                classes: {
                  input: css(classes.autocompleteFieldInput),
                },
              }}
              sx={{
                '.MuiFormControl-root': {
                  position: 'relative',
                },
              }}
              className={classNames(
                css(classes.autocompleteField),
                isDropdownOpen && css(classes.districtInputFocused),
              )}
              {...props}
            />
          )
        }}
        {...props}
      />
      {/* иконка полной дотации  поля населенный пункт(в интупе)*/}
      {dotationOptions?.includes(value) && (
        <Box
          sx={{
            position: 'absolute',
            top: '22%',
            right: '45px',
          }}
        >
          <img src={fullSubsidy} alt='full subsidy icon' />
        </Box>
      )}
    </>
  )
}

export default observer(DefaultAutocomplete)
